export enum Nav {
  BillingHistory = '/billing-and-payments/history',
  PayPlanSuccess = '/billing-and-payments/pay-plan/success',
  PayPlan = '/billing-and-payments/pay-plan/enroll',
  Alerts = '/manage-account/alerts',
  ContactInfo = '/manage-account/contact-info',
  ChangeMailing = '/manage-account/address/change',
  AddMailing = '/manage-account/address/add',
  UpdateLoginInfo = '/manage-account/update-login-info',
  PlanDetails = '/manage-account/plan-details',
  MultipleSAs = '/manage-account/service-agreements',
  RateRenewal = '/manage-account/rate-renewal',
  Wallet = '/billing-and-payments/wallet',
  AutopayEnrollSuccess = '/autopay-enroll-success',
  AutopayCancel = '/autopay-cancel',
  AutopayCancelChange = '/autopay-cancel-change',
  AutopayEnroll = '/autopay-enroll',
  AutopayChange = '/autopay-change',
  PaymentSuccess = '/payment-success',
  Payment = '/payment',
  MultiAccountSummary = '/multiaccount-summary',
  Closed = '/closed',
  PendingStart = '/pending-start',
  Seasonal = '/seasonal',
  AccountSummary = '/account-summary',
  Register = '/register',
  RegisterAccount = '/register-account',
  Forgot = '/forgot',
  Login = '/login',
  ErrorPage = '/error-page',
  CancelFuturePayment = '/cancel-future-payment',
  CancelFuturePaymentSuccess = '/cancel-future-payment-success',
  Reset = '/authentication/reset',
  RateChange = '/rate-change',
  RateChangeSuccess = '/rate-change-success',
  ManageAccount = '/manage-account',
  StopSuccess = '/stop-success',
  OneTimePayment = '/authentication/one-time-payment',
  TechnicalError = '/technical-error',
  AccountLookup = '/authentication/accountlookup',
  OneTimePaymentSuccess = '/authentication/one-time-payment/success',
  OneTimePaymentError = '/authentication/one-time-payment/error',
  SSMRates = '/manage-account/choose-rates',
  ScheduleService = '/manage-account/schedule-service',
  UnauthenticatedRateRenewal = '/accounts/ratesrenewal',
  UnauthenticatedRateRenewalError = '/accounts/ratesrenewal/error',
  UnauthenticatedRateRenewalSuccess = '/accounts/ratesrenewal/success',
  StartServiceAddress = '/manage-account/start-service',
  StartServiceScheduleService = '/manage-account/start-service/schedule-service',
  StartServiceChooseRates = '/manage-account/start-service/choose-rates',
  StartSuccess = '/manage-account/start-service/start-success',
  MoveService = '/manage-account/transfer-service',
  MoveServiceAddress = '/manage-account/transfer-service/choose-address',
  MoveServiceScheduleService = '/manage-account/transfer-service/schedule-service',
  MoveServiceChooseRates = '/manage-account/transfer-service/choose-rates',
  MoveSuccess = '/manage-account/transfer-service/move-success',
  ReconnectSuccess = '/manage-account/reconnect-service/reconnect-success',
  ReconnectRates = '/manage-account/reconnect-service/reconnect-rates',
  ReconnectService = '/manage-account/reconnect-service',
  ReconnectError = '/manage-account/reconnect-service/reconnect-error',
  Outage = '/site-unavailable',
  BioTerms = '/biometrics-terms',
  UnauthenticatedPaperless = '/accounts/paperless',
  UnauthenticatedPaperlessError = '/accounts/paperless/error',
  UnauthenticatedPaperlessSuccess = '/accounts/paperless/success',
  Advantage = '/advantage',
  AppError = '/app-error',
}
